import { styled } from "goober";
import { useContext } from "react";
import { ActivityAnimationContext } from "./ActivityAnimationContext";
import { PulsingIcon } from "./PulsingIcon";
import { Blob } from "./Blob";
import { Icon, type IconName } from "./Icon";
import { ShimmerSpan } from "./ShimmerSpan";
import { Text } from "./Text";
import { TypewriterSpan } from "./TypewriterSpan";

const Indicator = styled(PulsingIcon)`
  display: flex;
  align-items: stretch;
  justify-content: center;
  height: 12px;
  width: 12px;
`;

const Name = styled("span")`
  font-weight: 450;
  color: var(--text-primary);
  margin-right: 6px;
`;

type Props = {
  color?: string;
  icon: IconName;
  name?: string | null;
  done: boolean;
  interrupted?: boolean;
  pastParticiple: string;
  inProgress: string;
  failure?: string;
};
export function Step({
  color,
  icon,
  name,
  done,
  interrupted,
  pastParticiple,
  inProgress,
  failure,
}: Props) {
  const statusText = failure ?? (done ? pastParticiple : inProgress);
  const pending =
    useContext(ActivityAnimationContext)?.live ?? (!done && !interrupted);

  return (
    <>
      <Indicator data-pending={pending}>
        {color ? (
          <Blob colors={[color]} width={4} />
        ) : (
          <Icon name={icon} size={12} color="var(--text-secondary)" />
        )}
      </Indicator>
      <Text variant="text-small" color="var(--text-secondary)" ellipsis>
        {name && <Name>{name}</Name>}
        {statusText && (
          <ShimmerSpan data-pending={pending}>
            <TypewriterSpan>{statusText}</TypewriterSpan>
          </ShimmerSpan>
        )}
      </Text>
    </>
  );
}
